import React from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { OverseasRealEstatePositionListItemFragment } from 'views/utils/graphql/graphql';
import { ListItem } from 'views/mutual/list';
import { PagePathFactory } from 'constants/pagePath';
import { formatPrice } from 'views/utils/converter';
import { IssuanceDocumentType } from 'constants/IssuanceDocument';
import { ProductType, ProductTypeMap } from 'constants/productType';
import { PositionStatus, PositionStatusMap } from 'constants/position';

type OverseasRealEstatePositionListItemProps = {
  itemIndex: number;
  position: OverseasRealEstatePositionListItemFragment;
};

const fileIcon = findIcon(IconName.file);

const OverseasRealEstatePositionListItem: React.FC<OverseasRealEstatePositionListItemProps> = ({
  itemIndex,
  position,
}: OverseasRealEstatePositionListItemProps) => {
  return (
    <ListItem itemIndex={itemIndex} className="overseasRealEstatePositionListItem">
      <div className="overseasRealEstatePositionListItem_symbolName">
        <div className="overseasRealEstatePositionListItem_label">案件名</div>
        <div className="overseasRealEstatePositionListItem_value">{position.SymbolName}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_realEstateName">
        <div className="overseasRealEstatePositionListItem_label">対象物件名</div>
        <div className="overseasRealEstatePositionListItem_value">{position.RealEstateName}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_paLDistMonth">
        <div className="overseasRealEstatePositionListItem_label">任意組合決算月</div>
        <div className="overseasRealEstatePositionListItem_value">
          {position.PaLDistMonth.map((x, index) => (
            <>
              {x}
              {index + 1 < position.PaLDistMonth.length && <br />}
            </>
          ))}
        </div>
      </div>
      <div className="overseasRealEstatePositionListItem_rate">
        <div className="overseasRealEstatePositionListItem_label">事業開始時為替レート(1.00)米ドル</div>
        <div className="overseasRealEstatePositionListItem_value">{position.InitialExchangeRate}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_investmentJPY">
        <div className="overseasRealEstatePositionListItem_label">出資金額(¥)</div>
        <div className="overseasRealEstatePositionListItem_value">{formatPrice(position.InvestmentAmountYen)}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_contractDate">
        <div className="overseasRealEstatePositionListItem_label">契約締結日</div>
        <div className="overseasRealEstatePositionListItem_value">{position.ContractDate}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_projectedHoldingPeriod">
        <div className="overseasRealEstatePositionListItem_label">想定保有期間</div>
        <div className="overseasRealEstatePositionListItem_value">{position.ProjectedHoldingPeriod}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_operatingEndDate">
        <div className="overseasRealEstatePositionListItem_label"><span>任意組合終了日</span><span>(事業終了予定日)</span></div>
        <div className="overseasRealEstatePositionListItem_value">{position.OperatingEndDate}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_status">
        <div className="overseasRealEstatePositionListItem_label">ステータス</div>
        <div className="overseasRealEstatePositionListItem_value">{position.Status}</div>
      </div>
      <div className="overseasRealEstatePositionListItem_contract">
        <div className="overseasRealEstatePositionListItem_label">契約関連書類</div>
        <div className="overseasRealEstatePositionListItem_value">
          {position.HasIssuanceDoc ? (
            <NavLink
              data-label="契約関連書類"
              to={PagePathFactory.issuanceDocumentContract(
                ProductTypeMap[position.ProductType as ProductType]?.documentType,
                position.Symbol,
              )}
            >
              <SvgIcon icon={fileIcon} size={IconSize.icon_s} />
            </NavLink>
          ) : (
            <div className="disabled">
              <SvgIcon icon={fileIcon} size={IconSize.icon_s} />
            </div>
          )}
        </div>
      </div>
    </ListItem>
  );
};

export type OverseasRealEstatePositionListProps = {
  items: Array<OverseasRealEstatePositionListItemFragment | null>;
};
export const OverseasRealEstatePositionList = ({ items }: OverseasRealEstatePositionListProps) => {
  return (
    <>
      {items
        ?.filter((x) => (x ? true : false))
        .map((item, index) => (
          <OverseasRealEstatePositionListItem key={index} itemIndex={index} position={item!} />
        ))}
    </>
  );
};
